import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QueryKey } from '@/config/query-client';

import { deleteTemplate as deleteTemplateAPI } from '@/api/v4/template.api';

export const useDeleteTemplate = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: deleteTemplateAPI,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [QueryKey.Templates] });
    },
  });

  return {
    deleteTemplate: mutation.mutateAsync,
  };
};
